import { subscribeToAgentJob, unsubscribeFromAgentJob } from "../channels/agent_job_channel";

export default function registerAgentJob(Alpine) {
  Alpine.data("agentJob", ({ jobId, status, tokensUsed, costPerMtok, tokenLimit }) => ({
    jobId,
    status,
    tokensUsed: tokensUsed || 0,
    costPerMtok: costPerMtok || 4.2,
    tokenLimit: tokenLimit || 0,

    get tokenDisplay() {
      return new Intl.NumberFormat().format(this.tokensUsed) + " tokens";
    },

    get costDisplay() {
      const cost = (this.tokensUsed / 1_000_000) * this.costPerMtok;
      return "~$" + cost.toFixed(2);
    },

    get budgetPercent() {
      if (!this.tokenLimit) return 0;
      return Math.min(100, Math.round((this.tokensUsed / this.tokenLimit) * 100));
    },

    get budgetNearLimit() {
      return this.budgetPercent >= 80;
    },

    init() {
      subscribeToAgentJob(this.jobId, {
        onMessage: (data) => {
          const container = document.getElementById("agent_messages");
          if (!container) return;

          // Skip if message already exists
          if (data.message_id && document.getElementById(`message_${data.message_id}`)) return;

          // Remove typing indicator before appending
          const typingIndicator = document.getElementById("typing-indicator");
          if (typingIndicator) typingIndicator.remove();

          container.insertAdjacentHTML("beforeend", data.html);
          this.scrollToBottom();
        },
        onMessageUpdate: (data) => {
          const existing = document.getElementById(`message_${data.message_id}`);
          if (existing) {
            existing.outerHTML = data.html;
            this.scrollToBottom();
          }
        },
        onTokenUpdate: (tokens) => {
          this.tokensUsed = tokens;
        },
        onStatusUpdate: (newStatus) => {
          this.status = newStatus;
          // Reload page to update status badge and input areas
          if (
            newStatus === "completed" ||
            newStatus === "failed" ||
            newStatus === "awaiting_approval" ||
            newStatus === "cancelled"
          ) {
            window.Turbo.visit(window.location.href);
          }
        }
      });

      this.scrollToBottom();
    },

    destroy() {
      unsubscribeFromAgentJob();
    },

    scrollToBottom() {
      this.$nextTick(() => {
        const el = this.$refs.messages;
        if (el) el.scrollTop = el.scrollHeight;
      });
    }
  }));
}
